import { mapState } from 'vuex'
import { RecordRTCPromisesHandler, invokeSaveAsDialog } from 'recordrtc'
import SocketIO from 'socket.io-client'

export default {
  data () {
    return {
      socket: null,
      pc: [],
      receivingCall: null,
      recorder: null,
    }
  },

  computed: {
    ...mapState('videoCall', [
      'localStream',
    ]),
  },

  methods: {
    newSocket () {
      this.socket = SocketIO(process.env.SOCKET_HOST)
      this.socket.on('connect', () => {
        console.log('Signaling server connected')
      })

      this.socket.on('callIn', data => {
        this.receivingCall = data
      })

      this.socket.on('newUser', data => {
        this.socket.emit('newUserStart', { to: data.socketId, sender: this.socket.io.engine.id })
        this.pc.push(data.socketId)
        this.init(true, data.socketId)
      })

      this.socket.on('newUserStart', data => {
        this.pc.push(data.sender)
        this.init(false, data.sender)
      })

      this.socket.on('iceCandidates', async data => {
        if (data.candidate) {
          await this.pc[data.sender].addIceCandidate(new RTCIceCandidate(data.candidate))
        }
      })

      this.socket.on('sdp', async data => {
        if (data.description.type === 'offer') {
          if (data.description) {
            await this.pc[data.sender].setRemoteDescription(new RTCSessionDescription(data.description))
          }

          this.localStream.getTracks().forEach((track) => {
            this.$store.commit('videoCall/SET_CONNECTED', true)
            // this.pc[data.sender].addTrack(track, this.localStream)
          })

          let answer = await this.pc[data.sender].createAnswer()

          await this.pc[data.sender].setLocalDescription(answer)

          this.socket.emit('sdp', { description: this.pc[data.sender].localDescription, to: data.sender, sender: this.socket.io.engine.id })
        } else if (data.description.type === 'answer') {
          await this.pc[data.sender].setRemoteDescription(new RTCSessionDescription(data.description))
        }
      })

      this.socket.on('destroy', () => {
        this.socket.emit('destroy', { room: this.receivingCall.room })
        this.destroyStreaming()
      })
    },

    init (createOffer, partnerName) {
      this.pc[partnerName] = new RTCPeerConnection({})

      if (this.localStream && this.localStream.getTracks().length) {
        this.localStream.getTracks().forEach(track => {
          this.pc[partnerName].addTrack(track, this.localStream)
        })
      }

      if (createOffer) {
        this.pc[partnerName].onnegotiationneeded = async () => {
          let offer = await this.pc[partnerName].createOffer()

          await this.pc[partnerName].setLocalDescription(offer)

          this.socket.emit('sdp', { description: this.pc[partnerName].localDescription, to: partnerName, sender: this.socket.io.engine.id })
        }
      }

      this.pc[partnerName].onicecandidate = ({ candidate }) => {
        this.socket.emit('iceCandidates', { candidate: candidate, to: partnerName, sender: this.socket.io.engine.id })
      }

      this.pc[partnerName].ontrack = (e) => {
        this.$store.commit('videoCall/SET_REMOTE_STREAM', e.streams[0])
      }

      this.pc[partnerName].onsignalingstatechange = () => {
        switch (this.pc[partnerName].signalingState) {
          case 'closed':
            console.log("Signaling state is 'closed'")
            this.$store.dispatch('videoCall/stopStreaming')
            break
        }
      }
    },

    stopStream () {
      this.socket.emit('unsubscribe', {
        room: this.receivingCall.room,
        socketId: this.socket.io.engine.id,
      })
      this.destroyStreaming()
    },

    async getMedia () {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        })

        this.recorder = new RecordRTCPromisesHandler(stream, { type: 'video' })

        this.recorder.startRecording()

        this.$store.commit('videoCall/SET_LOCAL_STREAM', stream)
      } catch (err) {
        this.$log.error(`Error while getting User media, Error: `, err)
      }
    },

    videoOnOff () {
      this.localStream.getVideoTracks()[0].enabled = !this.localStream.getVideoTracks()[0].enabled
    },

    async destroyStreaming () {
      await this.recorder.stopRecording()
      let blob = await this.recorder.getBlob()
      invokeSaveAsDialog(blob, 'video.webm')
      this.receivingCall = null
      this.videoOnOff()
      this.pc = []
      this.$store.dispatch('videoCall/stopStreaming')
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/videoCall.js